import { render, staticRenderFns } from "./DropdownList.vue?vue&type=template&id=27355faf&"
import script from "./DropdownList.vue?vue&type=script&lang=ts&"
export * from "./DropdownList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports